export default ({ time, description }, parentKey = '') => {
  const segmentId = time instanceof Array ? time.map((segment) => segment.time).join(' - ') : time;
  return `${parentKey ? `${parentKey}/` : ''}${segmentId}(${description})`;
};
